// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedExtaro300_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9823 0C7.57051 0 3.99409 2.68629 3.99409 6H4V7H0V14.5L3.99409 15.5V24H5.99113V7H6V6H5.99113C5.99113 5.1138 6.46471 4.15901 7.53199 3.35736C8.59989 2.55525 10.1667 2 11.9823 2H16.9749V4H13.9793L14.8521 8.6616L11.9824 11.5355L13.3945 12.9497L15.298 11.0434L15.4771 12H20.4697L20.6544 11.0134L22.5879 12.9497L24 11.5355L21.1003 8.63158L21.9675 4H18.9719V0H11.9823ZM17.1345 10H18.8123L19.5612 6H16.3856L17.1345 10ZM1.99704 9H3.99409V13.4384L1.99704 12.9384V9Z" class="svg-bg"/>
</svg>
`;
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M34 4H27.5009C20.1076 4.00024 14.006 7.05334 13.1133 10.999H15.174C16.1667 8.16193 21.3074 6.0002 27.5 6H32V10H34V4Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M29 12H37L36.3333 18.6667 41 21V23L36.1429 20.5714 36 22H30L29.8571 20.5714 25 23V21L29.6667 18.6667 29 12ZM31 14H35L34.5 20H31.5L31 14ZM7 13H15V40H17.998L18.999 42H9L10 40H13V24.5L7 23V13ZM9 15H13V22.5L9 21.5V15ZM9 42C10.6569 42 12 43.3431 12 45 12 46.6569 10.6569 48 9 48 7.34315 48 6 46.6569 6 45 6 43.3431 7.34315 42 9 42ZM10 45C10 45.5523 9.55228 46 9 46 8.44772 46 8 45.5523 8 45 8 44.4477 8.44772 44 9 44 9.55228 44 10 44.4477 10 45ZM18.999 42C20.6559 42 22 43.3431 22 45 22 46.6569 20.6569 48 19 48 17.3431 48 16 46.6569 16 45 16 43.3435 17.3426 42.0005 18.999 42ZM19 46C19.5523 46 20 45.5523 20 45 20 44.4477 19.5523 44 19 44 18.4477 44 18 44.4477 18 45 18 45.5523 18.4477 46 19 46Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedExtaro300 is a generated icon component.
 */
let IconMedExtaro300 = IconMedExtaro300_1 = class IconMedExtaro300 extends IconBaseElement {
    render() {
        return html `${IconMedExtaro300_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedExtaro300.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s48IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s48IconSvg],
    ['s72', _s48IconSvg],
    ['s80', _s48IconSvg],
]);
IconMedExtaro300 = IconMedExtaro300_1 = __decorate([
    customElement('zui-icon-med-extaro-300')
], IconMedExtaro300);
export { IconMedExtaro300 };
